import useApi from '../api';

export async function submitUpdatePlaylist(data : any ){
  // To clean posted data
  const {put} = useApi();
  console.log({data});
  const itemId = data.id;
  const { responseBody } = await put('api/playlists/'+itemId,[data], {isLogoutOnInvalidAuth: true});
  
  const responseData = responseBody;
  return responseData;
}